import React, { useState, useEffect } from 'react';

export default function PersonaIndoorSelector({ clienteId, personaAtual, onChange }) {
  const [personas, setPersonas] = useState([]);
  const [ativa, setAtiva] = useState(personaAtual || 'indoor_roberto_tradicional');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    fetch('/api/locutor/personas-indoor')
      .then(r => r.json())
      .then(d => { if (d.personas) setPersonas(d.personas); })
      .catch(err => console.warn('[PersonaIndoor] Erro ao carregar personas:', err));
  }, []);

  useEffect(() => {
    setAtiva(personaAtual || 'indoor_roberto_tradicional');
  }, [personaAtual]);

  async function selecionarPersona(personaId) {
    if (personaId === ativa || salvando) return;
    setSalvando(true);
    try {
      const res = await fetch(`/api/locutor/persona-indoor/${clienteId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ personaId }),
      });
      if (res.ok) {
        setAtiva(personaId);
        if (onChange) onChange(personaId);
      }
    } catch (err) {
      console.error('[PersonaIndoor] Erro ao salvar:', err);
    } finally {
      setSalvando(false);
    }
  }

  if (!personas.length) return null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 8 }}>
      {personas.map(p => {
        const isAtiva = ativa === p.id;
        return (
          <div
            key={p.id}
            onClick={() => selecionarPersona(p.id)}
            style={{
              padding: 12,
              borderRadius: 0,
              cursor: salvando ? 'not-allowed' : 'pointer',
              background: isAtiva ? 'rgba(var(--brand-rgb),0.15)' : 'rgba(var(--neutral-400-rgb),0.6)',
              border: isAtiva ? '1px solid var(--brand-500)' : '1px solid rgba(var(--neutral-300-rgb),0.4)',
              transition: 'border 0.15s, background 0.15s',
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--text-primary)', marginBottom: 3 }}>
              {p.nome}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginBottom: 6, lineHeight: 1.4 }}>
              {p.descricao}
            </div>
            <div style={{
              fontSize: 11,
              color: 'var(--text-muted)',
              fontStyle: 'italic',
              lineHeight: 1.4,
              borderTop: '1px solid rgba(var(--neutral-300-rgb),0.4)',
              paddingTop: 6,
            }}>
              "{p.exemploFala}"
            </div>
          </div>
        );
      })}
    </div>
  );
}
